import * as yup from 'yup';

export const fanCreateProfileSchema = yup.object().shape({
  fullName: yup.string().required('Please enter your full name'),
});
